import { render, staticRenderFns } from "./DmBatchRow.vue?vue&type=template&id=389cb42c&scoped=true&"
import script from "./DmBatchRow.vue?vue&type=script&lang=js&"
export * from "./DmBatchRow.vue?vue&type=script&lang=js&"
import style0 from "./DmBatchRow.vue?vue&type=style&index=0&id=389cb42c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cb42c",
  null
  
)

export default component.exports